import { View, StyleSheet, useWindowDimensions } from 'react-native';
import { Icon, Text, theme } from '@socrait/react';

import { SMALL_SCREEN_WIDTH } from '~/constants';

export const DescriptionColumn = () => {
  const { width } = useWindowDimensions();
  const smallScreen = width < SMALL_SCREEN_WIDTH;
  return (
    <View style={[styles.description, smallScreen && styles.descriptionSmall]}>
      <Icon type="streaming" />
      <Text style={[styles.descriptionText, styles.descriptionHeader]}>Voice Names</Text>
      <Text style={styles.descriptionText}>Voice names are the names you use in class to call on your students.</Text>
      <Text style={styles.descriptionText}>
        They could be nicknames, first names, last names, or hybrids like "John A" and "John R".
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  description: {
    alignItems: 'center',
    backgroundColor: theme.colors.primaryPurple,
    gap: theme.spacing.xlarge,
    justifyContent: 'center',
    padding: theme.spacing.xlarge + theme.spacing.small,
    width: 220,
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
  },
  descriptionSmall: {
    position: 'relative',
    width: '100%',
  },
  descriptionHeader: {
    fontSize: theme.fontSizes.xmedium,
    fontWeight: theme.fontWeights.bold,
  },
  descriptionText: {
    color: theme.colors.white,
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.small,
    textAlign: 'center',
  },
});
